<template>
  <div class="privacy-page">
    <!-- 页面头部 -->
    <header class="privacy-header">
      <div class="container">
        <h1>闪电心算隐私协议</h1>
        <p class="update-date">更新日期：2025年11月20日</p>
        <p class="update-date">生效日期：2025年11月20日</p>
      </div>
    </header>

    <!-- 主要内容区 -->
    <main class="privacy-content container">
      <!-- 前言/引言 -->
      <section class="privacy-section">
        <h2>引言</h2>
        <div class="content-placeholder">
          <!-- 在这里添加你的内容 -->
          欢迎使用我们的服务。我们尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，我们会按照本隐私政策的规定收集、使用、存储和披露您的个人信息。但我们将以高度的勤勉、审慎义务对待这些信息。除本隐私政策另有规定外，在未征得您事先许可的情况下，我们不会将这些信息对外披露或向第三方提供。
        </div>
      </section>
      <!-- 信息收集 -->
      <section class="privacy-section">
        <h2>1. 信息收集</h2>
        <h3>1.1用户信息</h3>
        <div class="content">
          我们可能收集以下用户信息：<br>
          （1）答题记录；<br>
          （2）答题进度；<br>
          （3）AndroidID，PhoneID（唯一手机识别符）<br>
          （4）本地储存；用于保存用户做题记录。<br>
          （5）软件列表；用于保证您在线升级客户端最新版本。<br>
        </div>
        <h3>1.2第三方SDK服务收集使用权限的场景：</h3>
        <div class="content">
          在某些特定业务情况下，为了提高业务处理能力，提升响应速度以及其他方面的考虑，我们可能会使用第三方服务商提供的软件服务工具包（简称SDK）来为您提供服务，这些SDK可能会收集您的个人信息，我们会在您授权后使用收集这些信息，这些SDK以及内容包括：<br>
          （1）微信SDK：<br>
          第三方SDK名称：微信OpenSDK Android<br>
          第三方SDK提供方的公司名称：深圳市腾讯计算机系统有限公司<br>
          使用目的及功能场景：微信OpenSDK Android是一款为开发者开发运营的APP提供实现微信分享与收藏、微信登录和微信支付功能等相关能力的软件开发工具包<br>
          处理的个人信息类型：<br>
          （1.1）用户的微信头像、昵称信息；<br>
          （1.2）网络权限；<br>
          （1.3）设备唯一标识，基本设备信息。<br>
          （1.4）软件安装列表。<br>
          实现SDK产品功能所需的权限：验证设备是否安装微信APP（未安装则无法使用SDK功能）<br>
          第三方SDK隐私政策链接：
          <a
              href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8"
              style="color: blue; text-decoration: underline; cursor: pointer;">
            微信OpenSDK Android个人信息处理规则
          </a><br>
          （2）支付宝SDK：<br>
          第三方SDK名称：APP支付客户端SDK<br>
          第三方SDK提供方的公司名称：支付宝(杭州)信息技术有限公司<br>
          使用目的及功能场景：APP支付客户端SDK是一款为开发者开发运营的APP提供实现支付宝支付功能的软件开发工具包<br>
          处理的个人信息类型：<br>
          （2.1）网络权限；<br>
          （2.2）设备唯一标识；<br>
          （2.3）基本设备信息；<br>
          （2.4）软件安装列表。<br>
          第三方SDK隐私政策链接：
          <a
              href="https://opendocs.alipay.com/open/54/01g6qm#%E6%94%AF%E4%BB%98%E5%AE%9D%20App%20%E6%94%AF%E4%BB%98%E5%AE%A2%E6%88%B7%E7%AB%AF%20SDK%20%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96"
              style="color: blue; text-decoration: underline; cursor: pointer;">
            App 支付宝客户端SDK隐私说明
          </a><br>
        </div>

      </section>

      <!-- 信息使用 -->
      <section class="privacy-section">
        <h2>2. 信息使用</h2>
        <div class="content">
          我们收集的信息将用于：<br>
          （1）用户身份验证：通过微信OpenID，AndroidID，PhoneID识别用户身份；<br>
          （2）学习记录保存：保存您的答题历史和做题记录；<br>
          （3）分析用户行为以优化产品功能；<br>
          （4）保障服务安全和防止欺诈行为；<br>
          （5）遵守法律法规要求。
        </div>
      </section>

      <!-- 信息共享 -->
      <section class="privacy-section">
        <h2>3. 信息共享与披露</h2>
        <div class="content">
          我们承诺我们不会向第三方出售、出租或以其他方式披露您的个人信息，除非：<br>
          （1）获得您的明确同意；<br>
          （2）法律法规要求；<br>
          （3）保护我们的合法权益；<br>
          （4）保护用户或公众的安全。
        </div>
      </section>

      <!-- 信息存储 -->
      <section class="privacy-section">
        <h2>4. 信息存储</h2>
        <div class="content">
          我们将在中华人民共和国境内存储您的个人信息。我们会采取合理的安全措施保护您的信息安全；用户申请注销账号的，本公司将在规定期限内删除或匿名化处理用户的全部个人信息，不再保留。
        </div>
      </section>

      <!-- 信息安全 -->
      <section class="privacy-section">
        <h2>5. 信息安全</h2>
        <div class="content">
          我们采用行业标准的安全措施来保护您的个人信息，包括：<br>
          （1）数据加密传输和存储；<br>
          （2）访问控制和权限管理；<br>
          （3）定期安全审计和漏洞修复；<br>
          （4）员工隐私保护培训。
        </div>
      </section>

      <!-- 用户权利 -->
      <section class="privacy-section">
        <h2>6. 用户权利</h2>
        <div class="content">
          您有权：<br>
          （1）查询、更正或删除您的个人信息；可通过APP"我的" → "设置" → "个人信息管理"操作；<br>
          （2）撤回对个人信息处理的同意；<br>
          （3）要求我们停止处理您的个人信息；<br>
          （4）向相关监管部门投诉。
        </div>
      </section>

      <!-- 儿童隐私保护 -->
      <section class="privacy-section">
        <h2>7. 儿童隐私保护</h2>
        <div class="content">
          我们特别重视儿童的隐私保护。如果您是14周岁以下的儿童，请在监护人的陪同下阅读本协议，并在监护人同意后使用我们的服务。本APP不包含任何危害未成年人身心健康的内容（如暴力、色情、低俗等），不引导未成年人进行任何违法违规活动；不收集未成年人的非必要个人信息，收集的信息仅用于服务提供，且需经监护人同意，依法严格落实未成年人用户账号真实身份信息注册和登录要求；监护人可联系本公司，查询、修改、删除未成年人的个人信息，申请限制未成年人的使用时长
        </div>
      </section>

      <!-- 协议变更 -->
      <section class="privacy-section">
        <h2>8. 协议变更</h2>
        <div class="content">
          我们可能会不时更新本隐私协议。重大变更时，我们会通过应用内通知等方式告知您；更新后用户继续使用APP即视为同意变更后的隐私协议。
        </div>
      </section>

      <!-- 联系我们 -->
      <section class="privacy-section">
        <h2>9. 联系我们</h2>
        <div class="content">
          如您有任何疑问、意见或建议，请通过以下方式联系我们：<br><br>
          公司名称：沈阳藻慧网络科技有限公司<br>
          电子邮件：237160438@qq.com<br>
          反馈时间：工作日8:30-17:30
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="privacy-footer">
      <div class="container">
        <p>本隐私政策严格遵循《中华人民共和国个人信息保护法》《网络安全法》《数据安全法》《中华人民共和国未成年人保护法》《移动互联网应用程序信息服务管理规定》等相关法律法规，是本APP运营的合法依据，用户使用本APP，即视为同意本隐私政策的全部内容。</p>
        <p>© 2025 闪电心算 版权所有</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PrivatePolicy',
  methods:{

  }
};

</script>

<style scoped>
/* 基础样式 */
.privacy-page {
  width: 100%;
  min-height: 100vh; /* 确保占满屏幕高度 */
  background-color: #f9f9f9;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  line-height: 1.8; /* 提高行高，提升可读性 */
}

.container {
  max-width: 1000px; /* 内容最大宽度，避免过宽 */
  margin: 0 auto;
  padding: 0 20px;
}

/* 头部样式 */
.privacy-header {
  background-color: #fff;
  padding: 40px 0;
  border-bottom: 1px solid #eee;
}

.privacy-header h1 {
  font-size: 2.2rem;
  margin: 0 0 10px 0;
  color: #222;
}

.update-date {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

/* 内容区样式 */
.privacy-content {
  padding: 50px 0;
}

.privacy-section {
  background-color: #fff;
  padding: 30px;
  margin-bottom: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.privacy-section h2 {
  font-size: 1.5rem;
  margin: 0 0 20px 0;
  color: #222;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

/* 正文内容样式 */
.content {
  font-size: 1rem;
  color: #555;
}

.content br {
  margin-bottom: 12px; /* 优化换行间距 */
}

/* 页脚样式 */
.privacy-footer {
  background-color: #222;
  color: #aaa;
  padding: 30px 0;
  margin-top: 50px;
}

.privacy-footer p {
  margin: 0;
  font-size: 0.9rem;
  text-align: center;
}

/* 响应式调整（适配手机） */
@media (max-width: 768px) {
  .privacy-header h1 {
    font-size: 1.8rem;
  }

  .privacy-section {
    padding: 20px;
  }

  .privacy-section h2 {
    font-size: 1.3rem;
  }

  .content {
    font-size: 0.95rem;
  }
}
</style>